// CountBlog.jsx - Blog posts counter with real API integration
import React, { useEffect } from 'react';
import { Card, Statistic, Space, Tag, Progress, Tooltip, Typography } from 'antd';
import { FileTextOutlined, EyeOutlined, HeartOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getBlogStats } from '../../features/blog/blogSlice';

const { Text } = Typography;

const CountBlog = () => {
  const dispatch = useDispatch();
  const { stats, loading } = useSelector((state) => state.blogs);

  useEffect(() => {
    // Fetch blog statistics when component mounts
    dispatch(getBlogStats());
  }, [dispatch]);

  // Use real stats or fallback to defaults
  const {
    totalBlogs = 0,
    publishedBlogs = 0,
    draftBlogs = 0,
    totalViews = 0,
    totalLikes = 0,
    publishRate = 0
  } = stats;

  return (
    <Card 
      className="shadow-medium border border-border-light rounded-xl bg-white hover:shadow-hard transition-all duration-300 h-full"
      bodyStyle={{ padding: '24px' }}
      loading={loading}
    >
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-accent-blue to-purple-600 rounded-full flex items-center justify-center">
            <FileTextOutlined className="text-2xl text-white" />
          </div>
        </div>
        
        <Statistic
          title={
            <span className="text-text-secondary font-medium text-sm uppercase tracking-wide">
              Blog Posts
            </span>
          }
          value={totalBlogs}
          valueStyle={{
            color: '#8b5cf6',
            fontSize: '3rem',
            fontWeight: 'bold',
            fontFamily: 'Montserrat'
          }}
        />

        <Space direction="vertical" size="small" className="w-full mt-4">
          <div className="flex justify-between items-center">
            <Text className="text-text-secondary text-sm">Published Rate</Text>
            <Text className="text-purple-600 font-semibold">{publishRate}%</Text>
          </div>
          <Progress 
            percent={publishRate}
            strokeColor="#8b5cf6"
            trailColor="#f1f5f9"
            strokeWidth={8}
            showInfo={false}
          />
          
          <div className="flex justify-between mt-3">
            <Tooltip title={`Published: ${publishedBlogs} | Drafts: ${draftBlogs}`}>
              <Tag color="purple" className="flex items-center space-x-1">
                <EyeOutlined />
                <span>{publishedBlogs}</span>
              </Tag>
            </Tooltip>
            <Tooltip title={`Total Views: ${totalViews.toLocaleString()}`}>
              <Tag color="pink" className="flex items-center space-x-1">
                <HeartOutlined />
                <span>{totalViews > 999 ? `${Math.round(totalViews/1000)}k` : totalViews}</span>
              </Tag>
            </Tooltip>
          </div>

          {/* Additional stats row */}
          <div className="flex justify-center mt-2">
            <Tooltip title={`Total Likes: ${totalLikes.toLocaleString()}`}>
              <Tag color="red" className="flex items-center space-x-1">
                <HeartOutlined />
                <span>{totalLikes > 999 ? `${Math.round(totalLikes/1000)}k` : totalLikes}</span>
              </Tag>
            </Tooltip>
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default CountBlog;